export const isLoading = state => state.contactReducer.attachment.isLoading

export const isSuccess = state => state.contactReducer.attachment.isSuccess

export const attachments = state => state.contactReducer.attachment.attachments

export const totalAttachments = state => state.contactReducer.attachment.totalAttachments

export const options = state => state.contactReducer.attachment.options

export const history = state => state.contactReducer.attachment.history

export const totalHistory = state => state.contactReducer.attachment.totalHistory

export const permissions = state => state.contactReducer.attachment.permissions
